<template>
  <div class="recommend-keyword-list">
    <ul class="keyword-list">
      <li v-for="(keywordItem, index) in keywordList" :key="'key_word' + index" @click="()=>moveToRecommendTag(keywordItem)">
        {{keywordItem.text}}
      </li>
    </ul>
  </div>
</template>

<script>
import { SearchService } from '@/common/api/api.service'
import { parse } from 'query-string'
import { get } from 'lodash'

export default {
  name: 'RecommendSearchKeywordList',
  data () {
    return {
      keywordList: []
    }
  },
  methods: {
    setData () {
      SearchService.getRecommendSearchKeywordList().then(({ data }) => {
        this.keywordList = data
      })
    },
    moveToRecommendTag (keywordItem) {
      const uiCode = get(parse(keywordItem.link.split('?').pop()), 'uicode', '') || get(keywordItem, 'link', '').split('/').pop()
      if (uiCode !== '') { // List
        this.$router.push({ name: 'searchList', params: { uiCode: uiCode, section: uiCode } })
      } else {
        if (keywordItem.link.indexOf('https://') > -1) {
          location.href = keywordItem.link
        } else {
          this.$router.push(keywordItem.link.replace('captvpooq://', '') + '&search=y')
        }
      }
    }
  },
  created () {
    this.setData()
  }
}
</script>

<style scoped>
.recommend-keyword-list {
  overflow-y: scroll;
  width: 100%;
  height: 100%;
  padding: 0 20px;
}
ul.keyword-list li {
  margin: 28px 0;
  font-size: 14px;
  line-height: 20px;
  color: #a5a5a5;
  text-align: center;
}
</style>
